export default "__VITE_ASSET__D$ZaJ4UI__"